<template>
    <div
        class="base-switch"
        style="display: flex; align-items: center; justify-content: center"
    >
        <span
            @click="toggle"
            :id="elemId"
            :class="{
                'base-switch--on': booleanValue,
                'base-switch--off': !booleanValue,
            }"
            class="toggle-wrapper"
            :style="{
                'width' : defaultWidth + 'px',
                'height': defaultHeight + 'px'
            }"
        >
            <span
                class="toggle-background"
                :class="backgroundStyle"
            >
            </span>

            <span
                class="toggle-indicator"
                :class="indicatorClass"
                :style="indicatorStyle"
            >

            </span>
        </span>
    </div>
</template>

<script>
export default {
    name: "BaseSwitch",
    props: ['value', 'width', 'height', 'elemId'],

    computed: {
      backgroundStyle() {
          return {
                'disabled-toggle-background': !this.booleanValue,
                'enabled-toggle-background' : this.booleanValue
          }
      },
      indicatorStyle() {
          return {
              transform : this.booleanValue ? 'translate('+ this.defaultWidth / 2 +'px)' : 'translate(0)',
              'width' : this.indicatorWidth + 'px',
              'height' : this.indicatorHeight + 'px',
              'bottom' : this.indicatorBottom + 'px'
          }
      },
      indicatorClass() {
          return {
              'disabled-toggle-indicator' : !this.booleanValue,
              'enabled-toggle-indicator' : this.booleanValue
          }
      },

      booleanValue() {
          if(typeof this.value === 'boolean') {
              return this.value;
          }
          return this.value === 'true';
      },

      defaultWidth() {
          if(!this.width) {
              return 44;
          }
          return this.width;
      },

      defaultHeight() {
          if(!this.height) {
              return 22;
          }
          return this.height;
      },

      indicatorWidth() {
          return (this.defaultHeight / 2) + 1;
      },
      indicatorHeight() {
          return (this.defaultHeight / 2) + 1;
      },

      indicatorBottom() {
          return Math.floor((this.indicatorHeight * 42.5) / 100);
      }
    },

    methods: {
        toggle() {
            this.$emit('input', !this.value);
        }
    }
}
</script>

<style scoped lang="scss">

    .disabled-toggle-background {
        border: 1px solid $color-body-text;
        background-color: transparent;
    }
    .enabled-toggle-background {
       border: 1px solid $color-brand-primary;
       background-color: $color-brand-primary;
    }
    .disabled-toggle-indicator {
        background-color: $color-body-text;
    }
    .enabled-toggle-indicator {
        background-color: $color-on-primary;
    }

    .toggle-wrapper {
        display: inline-block;
        position: relative;
        cursor: pointer;
        border-radius: 9999px;
    }

    .toggle-background {
        display: inline-block;
        height: 100%;
        width: 100%;
        border-radius: 11px;
        transition: background-color .4s ease;
    }

    .toggle-indicator {
        position: absolute;
        left: 4px;
        border-radius: 11px;
        transition: transform .4s ease;
    }
</style>



// WEBPACK FOOTER //
// src/common/components/shared/BaseSwitch.vue